import React from 'react'
import Utils from 'live/lib/utils'
import { MarkersAnnotation } from '../../api'
import styled from 'styled-components'
import { removeDuplicates } from '../../utils'

/**
 * A table showing all curves of the marker
 */
export default function CurvesTable(props: { widgets: MarkersAnnotation['extra']['widgets'] }): JSX.Element {
    const [expanded, setExpanded] = React.useState<Set<number>>(new Set([props.widgets[0]?.widgetId]))

    const toggleExpanded = (id: number): void => {
        if (expanded.has(id)) expanded.delete(id)
        else expanded.add(id)

        setExpanded(new Set(expanded))
    }

    return (
        <StyledCurvesTable className="widgets">
            {props.widgets
                .filter(widget => widget)
                .map((widget, i) => {
                    const isExpanded = expanded.has(widget.widgetId)

                    return (
                        <div className={`curves-list ${isExpanded ? 'expanded' : ''}`} key={widget.widgetId}>
                            <div className="title" onClick={() => toggleExpanded(widget.widgetId)}>
                                {widget.widgetName} <i className="fa fa-angle-down" />
                            </div>
                            <div className="details">
                                <PointsList points={widget.points} />
                            </div>
                        </div>
                    )
                })}
        </StyledCurvesTable>
    )
}

export function PointsList(props: { points: MarkersAnnotation['extra']['widgets'][number]['points'] }): JSX.Element {
    return (
        <React.Fragment>
            {removeDuplicates(props.points).map((point, index) => {
                return (
                    <Curve key={index} className="curve">
                        <span className="color" style={{ backgroundColor: point.color }}></span>
                        <span className="name">{point.name}</span>
                        <span className="value">{Utils.formatNumber(point.value, 0, 2)}</span>
                        <span className="unit">{point.unit}</span>
                    </Curve>
                )
            })}
        </React.Fragment>
    )
}

const StyledCurvesTable = styled.div`
    width: 100%;

    .curves-list {
        margin-bottom: 10px;

        .title {
            cursor: pointer;
            background: #eeeeee;
            font-size: 14px;
            color: #364159;
            padding: 4px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'SourceSansPro-Semibold';
            position: relative;
            i {
                position: absolute;
                right: 5px;
                color: #37a3ef;
            }
        }
        .details {
            max-height: 0;
            transition: max-height 0.15s ease-out;
            overflow: hidden;
        }

        &.expanded {
            .details {
                max-height: 100%;
            }

            .title {
                i {
                    transform-origin: center;
                    transform: rotate(180deg);
                }
            }
        }
    }
`

const Curve = styled.div`
    display: flex;
    height: 21px;
    align-items: center;
    border: solid 1px #eee;
    border-top: none;
    padding-left: 3px;
    padding-right: 3px;
    span {
        display: block;
        font-size: 12px;
    }
    .color {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 5px;
    }
    .name {
        flex: 1;
        text-align: left;
    }
    .value,
    .unit {
        font-weight: bold;
    }
    .value {
        margin-right: 2px;
    }
`
